// 巡检详情
// 子管线
import React from 'react'
import { useState, useEffect, useRef } from 'react'
import { PlusOutlined, ArrowLeftOutlined, GlobalOutlined, UnlockOutlined, LockFilled } from '@ant-design/icons';
import { Button, Modal, Input, Pagination, Spin, message, Popconfirm, InputNumber } from 'antd';
import { Table } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom' //路由跳转使用 useNavigate react-router v6已经把usehistory替换成了useNavigate
import OperationBuilder from '@/components/TableBuilder/OperationBuilder';
import { GetRoutesList, GetRoutesInfo, AddRoutes, EditRoutes, ImportPoint, IdentificationStake, DelRoutes, exportWaypoints, ImportAirway, lockListData } from '@/services/shipping_line'
import { basicPath } from '@/router/config.js'
import local from '@/utils/local'
// import 'antd/dist/antd.dark.css';

const { TextArea } = Input;

function ShippingLineSon () {
  const navigate = useNavigate();
  const location = useLocation();//接受传值数据
  const limitsAuthority = useRef()//权限列表
  const PID = location.state.id;//主管线id
  const name = location.state.name;//主管线名称
  const btnsize = 'default';
  const token = local.get('cruise_m350_token');
  const [current, setCurrent] = useState(1);//第几页
  const [data, setData] = useState([]);//表格数据
  const [total, setTotal] = useState(0);//总共多少条
  const [loading, setLoading] = useState(false);
  const [showModle, setShowModel] = useState(false);//是否显示弹窗
  const [modelTitle, setModelTitle] = useState('');//弹窗标题
  const [choose_id, setChooseId] = useState('');//当前选中的id
  const [title, setTitle] = useState('');//单元名称
  const [des, setDes] = useState('');//单元备注
  const [length, setLength] = useState('');//单元长度

  const [search, setSearch] = useState({
    PID: PID,
    access_token: token,
    page: 1,
    perpage: 10,
    type: location.state.type
  });//查询

  const columns = [ //表格头
    {
      title: '单元名称',
      dataIndex: 'title'
    },
    {
      title: '总里程(km)',
      dataIndex: 'length',
      width: '160px',
      // sorter: {
      //     compare: (a, b) => a.chinese - b.chinese,
      //     multiple: 3,
      // },
    },
    {
      title: '更新时间',
      dataIndex: 'time',
      width: '200px',
    },
    {
      title: '锁定',
      dataIndex: 'is_lock',
      width: '60px',
      align: 'center',
      render: (text, record) => {
        return (
          text
            ? (
              <div className='col_primary pointer flex jcc align_center'>
                <Popconfirm
                  title="是否锁定?"
                  description="Are you sure to delete this task?"
                  onConfirm={async () => {
                    let obj = {
                      access_token: token,
                      RID: record.id,
                      is_lock: 0
                    }
                    let res = await lockListData(obj)
                    if (res.ret !== 200) { return message.warning(res.msg || '数据跑丢了') }
                    getData(search, false);
                  }}
                  okText="锁定"
                  cancelText="取消"
                >
                  <UnlockOutlined className='col_primary pointer' />
                </Popconfirm>
              </div>
            )
            : (
              <div className='col_primary pointer flex jcc align_center'>

                <Popconfirm
                  title="是否解锁?"
                  description=""
                  onConfirm={async () => {
                    let obj = {
                      access_token: token,
                      RID: record.id,
                      is_lock: 1
                    }
                    let res = await lockListData(obj)
                    if (res.ret !== 200) { return message.warning(res.msg || '数据跑丢了') }
                    getData(search, false);
                  }}
                  okText="解锁"
                  cancelText="取消"
                >

                  <LockFilled className='col_primary pointer' />
                </Popconfirm>
              </div>
            )
        )
      }
    },
    {
      title: '地图',
      dataIndex: '',
      width: '100px',
      align: 'center',
      render: (text, record) => {
        if (search.type === 1) {
          if ((limitsAuthority.current)?.indexOf(9) > -1 && (limitsAuthority.current)?.indexOf(10) > -1 && (limitsAuthority.current)?.indexOf(11) > -1) {
            return (
              <div className='coL1890FF curPointer' style={{ display: (Number(record.length) > 0 ? 'block' : 'none') }} onClick={() => {
                window.open(basicPath + '/shipping_line_edit?' + record.id + `&${search.type}`);
              }}>
                <GlobalOutlined style={{ width: '16px', height: '16px' }} />
              </div>
            )
          } else { return (<GlobalOutlined style={{ width: '16px', height: '16px' }} />) }
        }
        if (search.type === 2) {
          if ((limitsAuthority.current)?.indexOf(39) > -1 && (limitsAuthority.current)?.indexOf(40) > -1 && (limitsAuthority.current)?.indexOf(41) > -1) {
            return (
              <div className='coL1890FF curPointer' style={{ display: (Number(record.length) > 0 ? 'block' : 'none') }} onClick={() => {
                window.open(basicPath + '/shipping_line_edit?' + record.id + `&${search.type}`);
              }}>
                <GlobalOutlined style={{ width: '16px', height: '16px' }} />
              </div>
            )
          } else { return (<GlobalOutlined style={{ width: '16px', height: '16px' }} />) }
        }
        if (search.type === 4) {
          if ((limitsAuthority.current)?.indexOf(58) > -1 && (limitsAuthority.current)?.indexOf(60) > -1 && (limitsAuthority.current)?.indexOf(62) > -1) {
            return (
              <div className='coL1890FF curPointer' style={{ display: (Number(record.length) > 0 ? 'block' : 'none') }} onClick={() => {
                window.open(basicPath + '/shipping_line_edit?' + record.id + `&${search.type}`);
              }}>
                <GlobalOutlined style={{ width: '16px', height: '16px' }} />
              </div>
            )
          } else { return (<GlobalOutlined style={{ width: '16px', height: '16px' }} />) }
        }
        if (search.type === 6) {
          if ((limitsAuthority.current)?.indexOf(81) > -1 && (limitsAuthority.current)?.indexOf(83) > -1 && (limitsAuthority.current)?.indexOf(85) > -1) {
            return (
              <div className='coL1890FF curPointer' style={{ display: (Number(record.length) > 0 ? 'block' : 'none') }} onClick={() => {
                window.open(basicPath + '/shipping_line_edit?' + record.id + `&${search.type}`);
              }}>
                <GlobalOutlined style={{ width: '16px', height: '16px' }} />
              </div>
            )
          } else { return (<GlobalOutlined style={{ width: '16px', height: '16px' }} />) }
        }
      }

    },
    {
      title: '操作',
      dataIndex: 'op',
      width: '100px',
      align: 'center',
      render: (_, record, index) => {
        if (record.is_lock === 1) {
          //高危 操作按钮
          const ButtonList2 = [
            {
              key: '0',
              type: 'SetUp',
              label: "修改",
              purview: false,
            },
            {
              key: '1',
              type: 'NodeCollapseOutlined',
              label: "上传管线",
              purview: false,
            },
            {
              key: 'divider',
              type: 'Divider',
              purview: false,
            },
            {
              key: '3',
              type: 'Delete',
              label: '删除',
              purview: false,
            },
          ]
          //常规 操作按钮
          const ButtonList1 = [
            {
              key: '0',
              type: 'SetUp',
              label: "修改",
              purview: false,
            },
            {
              key: '1',
              type: 'NodeCollapseOutlined',
              label: "上传管线",
              purview: false,
            },
            {
              key: '2',
              type: 'RotateLeftOutlined',
              label: "上传标识桩",
              purview: false,
            },
            {
              key: '4',
              type: 'NodeExpandOutlined',
              label: "导出管线",
              purview: false,
            },
            {
              key: '5',
              type: 'NodeIndexOutlined',
              label: "导出航点",
              purview: false,
            },
            {
              key: '6',
              type: 'RotateRightOutlined',
              label: "导出标识桩",
              purview: false,
            },
            {
              key: 'divider',
              type: 'Divider',
              purview: false,
            },
            {
              key: '3',
              type: 'Delete',
              label: '删除',
              purview: false,
            },
          ]
          //定点 操作按钮
          const ButtonList4 = [
            {
              key: '0',
              type: 'SetUp',
              label: "修改",
              purview: false,
            },
            {
              key: '1',
              type: 'NodeCollapseOutlined',
              label: "上传管线",
              purview: false,
            },
            {
              key: '7',
              type: 'NodeCollapseOutlined',
              label: "上传航线",
              purview: false,
            },
            {
              key: 'divider',
              type: 'Divider',
              purview: false,
            },
            {
              key: '3',
              type: 'Delete',
              label: '删除',
              purview: false,
            },
          ]
          // 常规巡检
          if (search.type === 1) {
            if ((limitsAuthority.current)?.indexOf(3) > -1) { ButtonList1[0].purview = true }
            if ((limitsAuthority.current)?.indexOf(5) > -1) { ButtonList1[1].purview = true }
            if ((limitsAuthority.current)?.indexOf(6) > -1) { ButtonList1[2].purview = true }
            if ((limitsAuthority.current)?.indexOf(8) > -1) { ButtonList1[3].purview = true; ButtonList1[4].purview = true; ButtonList1[5].purview = true }
            if ((limitsAuthority.current)?.indexOf(4) > -1 && ((limitsAuthority.current)?.indexOf(3) > -1 || (limitsAuthority.current)?.indexOf(5) > -1 || (limitsAuthority.current)?.indexOf(6) > -1 || (limitsAuthority.current)?.indexOf(8) > -1)) { ButtonList1[6].purview = true }
            if ((limitsAuthority.current)?.indexOf(4) > -1) { ButtonList1[7].purview = true }
          }
          // 高危巡检
          if (search.type === 2) {
            if ((limitsAuthority.current)?.indexOf(33) > -1) { ButtonList2[0].purview = true }
            if ((limitsAuthority.current)?.indexOf(35) > -1) { ButtonList2[1].purview = true }
            if (((limitsAuthority.current)?.indexOf(33) || (limitsAuthority.current)?.indexOf(35)) && (limitsAuthority.current)?.indexOf(34)) { ButtonList2[2].purview = true }
            if ((limitsAuthority.current)?.indexOf(34) > -1) { ButtonList2[3].purview = true }
          }
          // 定点巡检
          if (search.type === 4) {
            if ((limitsAuthority.current)?.indexOf(47) > -1) { ButtonList4[0].purview = true }
            if ((limitsAuthority.current)?.indexOf(51) > -1) { ButtonList4[1].purview = true }
            if ((limitsAuthority.current)?.indexOf(54) > -1) { ButtonList4[2].purview = true }
            if ((limitsAuthority.current)?.indexOf(49) > -1 && ((limitsAuthority.current)?.indexOf(47) > -1 || (limitsAuthority.current)?.indexOf(51) > -1 || (limitsAuthority.current)?.indexOf(54) > -1)) { ButtonList4[3].purview = true }
            if ((limitsAuthority.current)?.indexOf(49) > -1) { ButtonList4[4].purview = true }
          }
          // 综合巡检
          if (search.type === 6) {
            if ((limitsAuthority.current)?.indexOf(70) > -1) { ButtonList4[0].purview = true }
            if ((limitsAuthority.current)?.indexOf(73) > -1) { ButtonList4[1].purview = true }
            if ((limitsAuthority.current)?.indexOf(77) > -1) { ButtonList4[2].purview = true }
            if ((limitsAuthority.current)?.indexOf(71) > -1 && ((limitsAuthority.current)?.indexOf(70) > -1 || (limitsAuthority.current)?.indexOf(73) > -1 || (limitsAuthority.current)?.indexOf(77) > -1)) { ButtonList4[3].purview = true }
            if ((limitsAuthority.current)?.indexOf(71) > -1) { ButtonList4[4].purview = true }
          }
          return OperationBuilder(record, index, 'actions_drop', location.state.type === 1 ? ButtonList1 : location.state.type === 2 ? ButtonList2 : ButtonList4, Operation)

        } else {
          return <div className='opa25'>-</div>
        }

      }
    },
  ];


  // 操作按钮 回调
  const Operation = (record, index, type, key) => {
    switch (key) {
      case '0':
        getInfor(record.id);
        break;
      case '1':
        setChooseId(record.id);
        document.getElementById('importPoint').click();
        break;
      case '2':
        setChooseId(record.id);
        document.getElementById('identificationStake').click();
        break;
      case '3':
        delData(record.id);
        break;
      case '4':
        DCHD(key, record.id)
        break;
      case '5':
        DCHD(key, record.id)
        break;
      case '6':
        DCHD(key, record.id)
        break;
      case '7':
        setChooseId(record.id);
        document.getElementById('importRoute').click();
        break;
      default:
        break;
    }

  };


  //获取表格数据
  const getData = async (obj, isloding = true) => {
    if (isloding) { setLoading(true); }
    let res = await GetRoutesList(obj);
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错了');
      return;
    }
    setData([...res.data.items]);
    setTotal(res.data.total);
    setLoading(false);
  };

  // 导出航点
  const DCHD = async (key, id) => {
    let res = await exportWaypoints({
      access_token: token,
      id: id,
      type: key === '4' ? '1' : key === '5' ? '2' : key === '6' ? '3' : undefined
    })
    if (res.ret === 200) {
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = res.data
      document.body.appendChild(link);
      link.click();
      // 释放的 URL 对象以及移除 a 标签
      URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
      message.success('导出成功~')
    } else {
      message.warning(res.msg || '导出失败，请稍后重试~')
    }
  }

  //删除表格数据
  const delData = async (id) => {
    let res = await DelRoutes({
      access_token: token,
      id: id
    })
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错了');
      return;
    }
    message.success('删除成功');
    getData(search);
  };

  //修改表格数据
  const updateData = async () => {
    if (!title) {
      message.warning('请输入单元名称');
      return;
    }
    if (!des) {
      message.warning('请输入备注');
      return;
    }
    let obj = {
      access_token: token,
      title: title,
      des: des,
      length: length,
    }
    let res;
    if (choose_id) {
      obj.id = choose_id;
      res = await EditRoutes(obj);
    } else {
      obj.RID = PID;
      obj.type = search.type;
      res = await AddRoutes(obj);
    }
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错了');
      return;
    }
    message.success(choose_id ? '编辑成功' : '新增成功');
    setTitle('');
    setDes('');
    setLength('')
    setChooseId('');
    setShowModel(false);
    getData(search);
  };

  //获取管线详细信息
  const getInfor = async (id) => {
    let params = {
      access_token: token,
      id: id
    }
    let res = await GetRoutesInfo(params);
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错了');
      return
    }
    let val = res.data;
    setTitle(val.title);
    setDes(val.des);
    setLength(val.length);
    setChooseId(id);
    setShowModel(true);
    setModelTitle('编辑单元');
  };

  //新增管线
  const addPipe = async () => {
    setChooseId('');
    setShowModel(true);
    setModelTitle('新增单元');
  }

  //上传坐标
  const importData = async (val) => {
    var data = new FormData();
    // 创建一个表单数据
    data.append("access_token", token);
    data.append("id", val.id);
    data.append("file", val.file);
    let res = await ImportPoint(data);
    document.getElementById('importPoint').value = '';
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错了');
      return;
    }
    message.success('上传成功');
    getData(search);
  };

  //上传航线
  const importRoute = async (val) => {
    var data = new FormData();
    // 创建一个表单数据
    data.append("access_token", token);
    data.append("id", val.id);
    data.append("file", val.file);
    let res = await ImportAirway(data);
    document.getElementById('importRoute').value = '';
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错了');
      return;
    }
    message.success('上传成功');
    getData(search);
  };

  //上传标识桩
  const identificationStake = async (val) => {
    var data = new FormData();
    // 创建一个表单数据
    data.append("access_token", token);
    data.append("id", val.id);
    data.append("file", val.file);
    let res = await IdentificationStake(data);
    document.getElementById('identificationStake').value = '';
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错了');
      return;
    }
    message.success('上传成功');
    getData(search);
  };

  useEffect(() => {
    limitsAuthority.current = JSON.parse(local.get('cruise_m350_permissionsArr'))
    getData(search);
    //eslint-disable-next-line
  }, [])

  return (
    <div className="flex-col hei100 tablebackcol" style={{ overflowY: 'auto' }}>
      <div className="disFlex flexDirCol">
        <div className='flex-row aliItemsCen paddL24' style={{ width: '100% ', padding: '16px 24px' }}>
          <span onClick={() => { navigate(-1) }} className='curPointer'><ArrowLeftOutlined /> </span>
          <span className='fSize20 fWei500 margR12 margL18'>{name}</span>
        </div>
      </div>
      <div className="flex-col margRL24 paddRL24 backcol" style={{ marginBottom: '24px' }}>
        <div className="h64 flex-row aliItemsCen min-h64">
          <div className="fSize16 fWei600">单元列表</div>
          <div className="flex-auto"></div>
          <Button type="primary" icon={<PlusOutlined />} size={btnsize}
            onClick={() => {
              // if (local.get('cruise_m350_memberLevel') === '1') {
              //   message.warning('该账号无此操作权限!')
              // } else {
              //   addPipe()
              // }
              if (search.type === 1 && (limitsAuthority.current)?.indexOf(2) > -1) {
                addPipe()
              } else if (search.type === 2 && (limitsAuthority.current)?.indexOf(32) > -1) {
                addPipe()
              } else if (search.type === 4 && (limitsAuthority.current)?.indexOf(45) > -1) {
                addPipe()
              } else if (search.type === 6 && (limitsAuthority.current)?.indexOf(68) > -1) {
                addPipe()
              } else {
                message.warning('暂无权限！')
              }
            }}
          >
            新增
          </Button>
        </div>
        <div className="borbox">
          <Spin spinning={loading}>
            <Table
              rowKey='id'
              columns={columns}
              dataSource={data}
              pagination={false}
            />
          </Spin>
          <div className="min-h64 tt_a_r disFlex aliItemsCen">
            <Pagination
              total={total}
              showSizeChanger
              showQuickJumper={false}
              showTotal={total => `共 ${total} 条数据`}
              style={{ marginLeft: 'auto' }}
              current={current}
              onChange={
                (current, pageSize) => { //选择当前页后执行
                  let obj = { ...search };
                  obj.page = current;
                  setCurrent(current);
                  obj.perpage = pageSize;
                  setSearch({ ...obj })
                  getData(obj);
                }
              }
            />
          </div>
        </div>

      </div>
      <Modal title={modelTitle} open={showModle} maskClosable={false} cancelText='取消' okText="确定"
        onOk={() => { updateData() }}
        onCancel={() => {
          setTitle('');
          setDes('');
          setChooseId('');
          setLength()
          setShowModel(false);
        }}>
        <div className="margB24">
          <Input placeholder="单元名称" value={title} onChange={(e) => {
            setTitle(e.target.value)
          }} />
        </div>
        <div className="margB24">
          <InputNumber style={{ width: '100%' }} placeholder="单元长度" value={length} onChange={(e) => {
            setLength(e)
          }} />
        </div>
        <div>
          <TextArea id="" className="margT12 h54" value={des} rows={4} placeholder="单元描述"
            onChange={(e) => { setDes(e.currentTarget.value); }
            } />
        </div>
      </Modal>
      {/* 上传管线 */}
      <input id="importPoint"
        type="file"
        accept=".xls,.xlsx"
        hidden={true}
        onChange={(e) => {
          importData({ id: choose_id, file: e.target.files[0] })
        }}
      />
      {/* 上传标识桩 */}
      <input id="identificationStake"
        type="file"
        accept=".xls,.xlsx"
        hidden={true}
        onChange={(e) => {
          identificationStake({ id: choose_id, file: e.target.files[0] })
        }}
      />

      {/* 上传航线 */}
      <input id="importRoute"
        type="file"
        accept=".kmz"
        hidden={true}
        onChange={(e) => {
          importRoute({ id: choose_id, file: e.target.files[0] })
        }}
      />
    </div>
  );
}
export default ShippingLineSon